<template>
  <div class='LiveingActivityHome'>
    <live-banner></live-banner>
    <div class="list-wrap">
      <div class="flex-start title">
        <div class="fs-24" style="margin-right: 15px;">全部直播</div>
        <div class="tc-grey fs-14">为企业提供全渠道全场景的直播解决方案</div>
      </div>
      <div class="item-list">
        <div class="item" v-for="item in list" :key="item.innerid" @click="detailClick(item.livetype, item.innerid)">
          <div class="logo">
            <img :src="item.coverurl" alt="">
            <div class="status-box flex-start">
              <div class="status fs-12 tc-write" :class="status(item.status).cl"  v-if="[0,2,10,30].indexOf(item.status) > -1">
                <span class="el-icon-view" style="margin-right: 4px" v-if="[10,30].indexOf(item.status) > -1"></span>
                <span>{{status(item.status).name}}</span>
              </div>
              <div class="status fs-12 tc-write" v-if="[10,30,100].indexOf(item.status) > -1">{{formatNum(item.viewcount)}}热度</div>
            </div>
          </div>
          <div class="subject">{{item.subject}}</div>
          <div class="time blod" :class="[item.status==100?'ending':'']">{{status(item.status).text}}<span class="separate">|</span>{{item.livebegintime}}</div>
        </div>
      </div>
      <div class="living-loading tc-blue fs-14 tc" v-show="page.page<page.pagetotal">…加载中</div>
    </div> 
    <!-- <div class="f">
      <span v-for="item in icon" @click="fixClick(item.id)" :key='item.id' @mouseenter="mouseEnter(item.id)" @mouseleave="fId=''"><img :src="item.url" alt="item.text"><label for="" v-show="item.id==fId">{{item.text}}<i></i></label></span>
    </div> -->
    <contractUs :isContract='isContract' @cancel='cancel(0)'></contractUs>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import contractUs from './../components/contract-us.vue'
import LiveBanner from './../components/liveBanner.vue'
import {getIndexLiveByAll} from 'api/web-app'
import $ from 'jquery'
  export default {
    data() {
      return {
        // userIcon: require('@/common/images/leveing/public/pc/user_1.png'),
        userIcon: '',
        banner: [],
        key:'', //搜索字段,
        list:[],
        icon:[
          {id:2,text:'联系我们',url:require('@/common/images/leveing/live-detail/activity_fix2.png')},
          {id:3,text:'回到顶部',url:require('@/common/images/leveing/live-detail/activity_fix3.png')}
        ],
        isShowLive:false,
        isContract:false,
        fId:'',
        page: {
          page: 1,
          pagesize: 12,
          pagetotal: 0
        },
        liveLoading: false
      }
    },
    created(){
      if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MLiveIndex'
            })
        }
      this._getIndexList();
    },
    mounted(){
      let _this = this
      $(window).scroll(function () {
        if (_this.liveLoading || _this.page.page >= _this.page.pagetotal) return false
        if (($(document).height() - $(window).height()) -$(window).scrollTop() < 400 && _this.page.page <= _this.page.pagetotal) {
          _this.loadmore()
        }
      });
    },
    methods: {
      loadmore() {
        if (this.liveLoading) return false
        this.page.page++
        this.liveLoading = true
        this._getIndexList()
      },
      _getIndexList(){
        if (this.page.page == 1) this.setLoading(true)
        getIndexLiveByAll({
          data: this.page,
          success: data => {
            this.setLoading(false)
            this.liveLoading = false
            this.list = this.list.concat(data.data.content)
            this.page.pagetotal = data.data.pageinfo.pageCount
          },
          error: data => {
            this.liveLoading = false
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      searchClick(){
        this.$router.push({
          name:'LiveingSearch',
        })
      },
      fixClick(id){
        if(id==1){
          this.isShowLive=true;
        }
        if(id==2){
          this.isContract=true
        }else{
          document.documentElement.scrollTop = 0
        }
      },
      mouseEnter(id){
        this.fId=id;
      },
      cancel(type){ //1 预约  0  联系我们
        if(type){
          this.isShowLive=false;
        }else{
          this.isContract=false
        }
      },
      detailClick(type, id){
        if (type == 1) {
          // 视频直播
          let videoDataPc = this.$router.resolve({
            name: "VideoLiveing",
            query: {innerid:id}
          });
          window.open(videoDataPc.href, '_blank');
        } else {
          // 图文直播
          let routeDataPc = this.$router.resolve({
            name: "LiveingDetails",
            query: {innerid:id}
          });
          window.open(routeDataPc.href, '_blank');
        }
      },
      ...mapActions(['setLoading'])
    },
    computed: {
      formatNum () {
        return function (value) {
          let str = value
          if (value > 9999) {
            str = (value / 10000).toFixed(1) + 'w'
          }
          return str
        }
      },
      status () {
        return function(value) {
          let obj = {
            cl: '',
            text: '',
            name: ''
          }
          switch (value) { // 0未开始 2预告片 10直播中 30回放 100直播结束
            case 0: obj.cl = 'cl-trailer'
              obj.name = '预告'
              obj.text = '开播时间'
              break;
            case 2: obj.cl = 'cl-pending'
              obj.name = '未开始'
              obj.text = '开播时间'
              break;
            case 10: obj.cl = 'cl-living'
              obj.name = '观看直播'
              obj.text = '直播中'
              break;
            case 30: obj.cl = 'cl-review'
              obj.name = '观看回放'
              obj.text = '回放中'
              break;
            case 100: obj.cl = 'cl-ending'
              obj.name = '已结束'
              obj.text = '已结束'
              break;
          }
          return obj
        }
      },
      ...mapGetters(['domainInfo'])
    },
    components:{
      contractUs, LiveBanner
    },
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.LiveingActivityHome{
  .list-wrap{
    width: 1200px;
    margin: auto;
    .title{
      font-weight:bold;
      line-height:33px;
      margin: 30px 0 10px 0;
    }
    .item-list{
      display: flex;
      flex-wrap: wrap;
      justify-content: start;
      .item{
        width:300px;
        height:239px;
        padding: 10px 10px 0 10px;
        box-sizing: border-box;
        background:rgba(255,255,255,1);
        position: relative;
        margin-bottom: 20px;
        border-radius: 4px;
        overflow: hidden;
        &:hover{
          box-shadow:0px 1px 10px 0px rgba(0, 0, 0, 0.1);
        }
        .separate{
          margin:  0 6px;
          transform: scale(0.8);
          font-size: 12px;
          display: inline-block;
        }
        .logo{
          height: 157px;
          overflow: hidden;
          transition: 1s;
          cursor: pointer;
          border-radius: 4px;
          position: relative;
          img{
            width: 100%;
            height: 100%;
            transition: 1s;
            &:hover{
                transform: scale(1.2);
              }  
          }
        }
        .subject{
          font-size:15px;
          font-weight:bold;
          line-height: 21px;
          color:rgba(51,51,51,1);
          margin: 14px 0;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        &:hover .subject{
          height: 42px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
        }
        .status-box{
          position: absolute;
          top: 0;
          left: 0;
          .status{
            height: 20px;
            padding: 0 6px;
            line-height: 20px;
            background: rgba(0, 0, 0, 0.4);
          }
        }
        .status.cl-pending{
          background: #F1C205;
        }
        .status.cl-trailer{
          background:  #027AFF ;
        }
        .status.cl-living{
          background: #63CB89;
        }
        .status.cl-review{
          background: #525252 ;
        }
        .status.cl-ending{
          background: #525252;
        }
        &:hover .time{
          display: none;
        }
        .time{
          display: inline-block;
          box-sizing: border-box;
          font-size:12px;
          line-height: 23px;
          padding: 0 6px;
          color:#027AFF;
          background: #E7EEFF;
        }
        .ending{
          background: #F1F3F4;
          color: #999999;
        }
      }
    }
  }
  .living-loading{
    width: 200px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #027AFF;
    margin: 0 auto 40px auto;
    line-height: 40px;
  }
  .f{
    position: fixed;
    right: 48px;
    bottom: 100px;
    width: 30px;
    span{
      width: 50px;
      height: 50px;
      margin-bottom: 25px;
      cursor: pointer;
      position: relative;
      display: inline-block;
      label{
        position: absolute;
        top: 0;
        right: 0px;
        width: 100px;
        background: #000000;
        opacity: .7;
        color: #fff;
        font-size: 14px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        border-radius: 4px;
        right: 70px;
        i{
          overflow: hidden;
          width: 12px;
          height: 12px;
          background: #E9FBE4;
          border-bottom: 1px solid #000000;
          border-right: 1px solid #000000;
          display: inline-block;
          transform: rotate(45deg);
          position: absolute;
          right: -6px;
          top: 18px;
          background: #000;
        }
        }
      img{
        width: 50px
      }
      }
  }
}
</style>